import * as Realm from "realm-web";

export const appId = process.env.REACT_APP_ID;
const baseUrl = process.env.REACT_APP_FLOWERBASE_BASEURL
console.log("TCL: appId", appId);

const appConfig = {
  id: appId,
  timeout: 10000,
  baseUrl: baseUrl || 'http://localhost:8000'
};

export const app = new Realm.App(appConfig);
export const mongo = () =>
  app.currentUser.mongoClient("mongodb-atlas").db("pec-canvas-main");

export default app;
